import React from "react";
import {Form} from "../../XLibItems";
import {XInputDecimal} from "@michalrakus/x-react-web-lib/XInputDecimal";
import {XInputText} from "@michalrakus/x-react-web-lib/XInputText";
import {XFormFooter} from "@michalrakus/x-react-web-lib/XFormFooter";
import {XInputDate} from "@michalrakus/x-react-web-lib/XInputDate";
import {XFormBaseModif} from "@michalrakus/x-react-web-lib/XFormBaseModif";
import {XObject} from "@michalrakus/x-react-web-lib/XObject";
import {XFormHeader} from "@michalrakus/x-react-web-lib/XFormHeader";
import type {XFormProps} from "@michalrakus/x-react-web-lib/XFormBase";
import {XDropdownEnum} from "../user/XDropdownEnum";
import {EnumEnum, SluzbaEnum, TypPristupuSluzba} from "../../common/enums";
import {XMultiSelect} from "@michalrakus/x-react-web-lib/XMultiSelect";
import {XCheckbox} from "@michalrakus/x-react-web-lib/XCheckbox";
import {XInputFile} from "../klient/XInputFile";
import {XtDocTemplateDePaul} from "../../model/doc-templates/xt-doc-template.entity";
import {XFormColumn, XFormDataTable2} from "@michalrakus/x-react-web-lib/XFormDataTable2";

@Form("XtDocTemplate")
export class XtDocTemplateForm extends XFormBaseModif {

    constructor(props: XFormProps) {
        super(props);

        this.addField("vincentPoradProjekt.name");
    }

    createNewObject(): XObject {
        return {xtDocTemplateFieldToJoinList: [], typPristupuSluzba: {id: 204, code: "vsetkySluzby", name: "všetky služby"}, sluzbaList: [], availableInForms: false, version: 0};
    }

    mameSluzbu(sluzbaEnum: SluzbaEnum): boolean {
        return (this.state.object as XtDocTemplateDePaul)?.sluzbaList.filter((sluzba) => sluzba.kod === sluzbaEnum).length > 0;
    }

    render() {
        return (
            <div>
                <XFormHeader form={this} label="Doc template"/>
                <div className="x-form-row">
                    <div className="x-form-col">
                        <div className="x-form-inline-row">
                            <XInputDate form={this} field="modifDate" label="Modifikácia" readOnly={true}/>
                            <XInputText form={this} field="modifXUser.name" inputStyle={{width:'12.35rem'}} readOnly={true}/>
                            <XInputDecimal form={this} field="id" readOnly={true}/>
                        </div>
                        <XInputText form={this} field="label" label="Label" inputStyle={{width:'20rem'}}/>
                        <XInputText form={this} field="comment" label="Comment" inputStyle={{width:'35rem'}}/>
                        <XInputText form={this} field="entity" label="Entity" inputStyle={{width:'20rem'}}/>
                        <XFormDataTable2 form={this} assocField="xtDocTemplateFieldToJoinList" label="Fields to join">
                            <XFormColumn field="id" header="ID" readOnly={true} width="4rem"/>
                            <XFormColumn field="field" header="Field (path)" width="20rem"/>
                        </XFormDataTable2>
                        <XDropdownEnum form={this} assocField="typPristupuSluzba" label="Typ prístupu" enumEnumCode={EnumEnum.typPristupuSluzba}/>
                        <XMultiSelect form={this} assocToMany="sluzbaList" displayField="nazov" label="Služby" sortField="nazov" readOnly={(this.state.object as XtDocTemplateDePaul)?.typPristupuSluzba?.code !== TypPristupuSluzba.zadaneSluzby}/>
                        {this.mameSluzbu(SluzbaEnum.vincentPoradenstvo) ? <XDropdownEnum form={this} assocField="vincentPoradProjekt" label="Projekt" enumEnumCode={EnumEnum.vincentPoradProjekt}/> : null}
                        <XInputText form={this} field="templateId" label="Template ID" inputStyle={{width:'15rem'}}/>
                        <XDropdownEnum form={this} assocField="templateType" label="Template type" enumEnumCode={EnumEnum.xtTemplateType}/>
                        <XInputFile form={this} fileField="templateXFile" label="Template file" subdir="templates"/>
                        <XInputText form={this} field="fileNameTemplate" label="File name template" labelStyle={{width:'12.5rem'}} inputStyle={{width:'25rem'}}/>
                        <XCheckbox form={this} field="availableInForms" label="Available in forms"/>
                    </div>
                </div>
                <XFormFooter form={this}/>
            </div>
        );
    }
}
